/**
 * 存取缓存的名称
 */
export enum StorageName {
  // 登录会话密钥
  SessionKey = 'session_key',
  /** 后端全局访问地址 */
  ServiceDomain = 'service_domain',
  // 登录时的账号信息(用于记住密码)
  LoginAccountInfo = 'login_account_info',
  // 临时记录申购单选中数据
  TempApplyPurchaser = 'temp_apply_purchase',
  // 临时记录监管方申购单选中数据
  TempManageApplyPurchaser = 'temp_manage_apply_purchase',
  // 采购单列表打印配置
  PURCHASE_ORDER_PRINT_SETTING = 'PURCHASE_ORDER_PRINT_SETTING',
  // 供方配送任务列表打印配置
  DELIVERY_TASK_PRINT_SETTING = 'DELIVERY_TASK_PRINT_SETTING',
  // 监管方配送任务列表打印配置
  DELIVERY_TASK_PRINT_MANAGE_SETTING = 'DELIVERY_TASK_PRINT_MANAGE_SETTING',
  // 临时记录需方效期预警选中数据，盘点
  TempValidityWarning = 'temp_validity_warning',
  // 临时记录需方库存预警选中数据，申购
  TemInventoryWarning = 'temp_inventory_warning',
  // 临时记录需方库存预警选中数据，批量采购
  TemInventoryPurcahseWarning = 'temp_inventory_purchase_warning',
  // 申领单列表打印配置
  REQUISITION_PRINT_SETTING = 'REQUISITION_PRINT_SETTING',
  // 需方采购单列表打印配置
  PURCHASE_ORDER_PRINT_SETTING_PURCHASE = 'PURCHASE_ORDER_PRINT_SETTING_PURCHASE',
  // 登录数据仓库时的账号信息(用于记住密码)
  BILoginAccountInfo = 'bi_login_account_info',
  // 售后单列表打印配置
  AFTER_SALES_PRINT_SETTING_PURCHASE = 'AFTER_SALES_PRINT_SETTING_PURCHASE',
}

/**
 * 响应编码
 */
export enum ResponseCode {
  /**
   * 成功
   */
  Success = 200,
  /**
   * 没有访问权限，需要进行身份认证
   */
  Unauthorized = 401,
}

/** 基础配置信息 */
export enum Option {
  /** 防抖等待时长 */
  DebounceWait = 150,
}
